import React from "react";
import { useSelector } from "react-redux";
import { StatusChip } from "@akj-dev/shared-components";
import { Box } from "@mui/material";

export const CreditCheckStatus = () => {
  const fetching = useSelector<any, boolean>(
    (state) => state.account.creditCheckStatus?.fetching
  );
  const error = useSelector<any, boolean>(
    (state) => state.account.creditCheckStatus?.response?.status === "error"
  );
  const message = useSelector<any, boolean>(
    (state) => state.account.creditCheckStatus?.response?.message
  );

  if (fetching)
    return (
      <Box mb={1}>
        <StatusChip
          type="loading"
          title="Getting credit check status"
          message="Please wait..."
        />
      </Box>
    );

  if (error)
    return (
      <Box mb={1}>
        <StatusChip
          type="error"
          title="Error getting credit check status"
          message={message || "Error getting credit check status"}
        />
      </Box>
    );

  return null;
};
